"use client";
import { motion } from "framer-motion";
import AboutWisWiz from "../ouders/AboutWisWiz";
import ContentSelectV2 from "../contentselect/ContentSelectV2";

export default function HeroPremium() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" as const }}
    >
      <div className="mx-4 mt-12 mb-8">
        <ContentSelectV2 flow="full" />
      </div>
    </motion.div>
  );
}

/** Right-column content for the hero section (used by PremiumLanding) */
export function HeroPremiumSide() {
  return <AboutWisWiz hideWelcomeHeader />;
}
